import React from 'react';
import styled from 'styled-components';

import Picture from '../../../../containers/assets/instructor-onboarding-image9.png';

const Wrapper = styled.div`
  background: #f5f6f7;
  flex: 1;
`;

const Container = styled.div`
  padding: 40px;
  width: 80%;
  max-width: 794px;
`;

const Text1 = styled.div`
  font-family: 'Mukta Vaani';
  font-style: normal;
  font-weight: 500;
  font-size: 16px;
  line-height: 16px;
  color: rgba(0, 27, 59, 0.38);
  text-transform: uppercase;
`;

const Text2 = styled.div`
  font-family: 'Mukta Vaani';
  font-style: normal;
  font-weight: 700;
  font-size: 21px;
  line-height: 28px;
  color: rgba(0, 27, 59, 0.94);
  margin-top: 24px;
`;

const Text3 = styled.div`
  font-family: 'Mukta Vaani';
  font-style: normal;
  font-weight: 500;
  font-size: 16px;
  line-height: 24px;
  color: rgba(0, 27, 59, 0.6);
  margin-top: 12px;

  b {
    color: #ed716d;
  }

  ul {
    list-style-type: disc;
    margin-left: 15px;
    margin-top: 5px;

    li {
      font-family: 'Mukta Vaani';
      font-style: normal;
      font-weight: 500;
      font-size: 16px;
      line-height: 22px;
      color: rgba(0, 27, 59, 0.6);
    }
  }
`;

const Image = styled.div`
  display: flex;
  margin-top: 12px;
`;

const SettingUpGameplayStep1 = () => (
  <Wrapper>
    <Container>
      <Text1>Setting Up Gameplay</Text1>
      <Text2>Setting Up Gameplay</Text2>
      <Text3>
        All games include at least 1 <b>simulation round</b> and
        a <b>peer evaluation</b>. Let's walkthrough how you would
        setup a game for your course.
      </Text3>

      <Image>
        <img src={Picture} alt="" />
      </Image>
    </Container>
  </Wrapper>
);

export default SettingUpGameplayStep1;



// WEBPACK FOOTER //
// ./src/instructor/components/onboarding/setting-up-gameplay/step1.js